import cloneDeep from 'lodash/cloneDeep';
import formatDate from '@/services/general/formatDate';
import getTradByTypeFacture from '../facture/getTradByTypeFacture';

export default function miseEnFormeDuTableauDesEcheances(mouvement) {
  const data = [];
  mouvement.forEach((mouvementGeneral) => {
    const info = {
      dateEcheance: formatDate(mouvementGeneral.dateMouvement),
      remiseBancaireId: mouvementGeneral.remiseBancaireId,
      idEcheance: mouvementGeneral.id,
      montant: mouvementGeneral.credit > mouvementGeneral.debit
        ? mouvementGeneral.credit : mouvementGeneral.debit,
      montantRestant: mouvementGeneral.resteALettrer,
      inputLetterage: parseFloat('0,00'),
      solde: mouvementGeneral.resteALettrer,
      libelle: mouvementGeneral.libelle,
      idFacture: mouvementGeneral.factureId,
      modeReglement: mouvementGeneral.modeReglement,
      soldeSave: cloneDeep(mouvementGeneral.resteALettrer),
      operationDiverseId: mouvementGeneral.operationDiverseId,
      typeDePiece: mouvementGeneral.typeDePiece,
    };
    if (mouvementGeneral.facture !== null) {
      info.type = getTradByTypeFacture(mouvementGeneral.facture.sousType);
      info.montant = mouvementGeneral.debit;
    }
    data.push(info);
  });
  data.sort((a, b) => {
    const dateA = new Date(a.dateEcheance);
    const dateB = new Date(b.dateEcheance);
    return dateA - dateB;
  });
  return data;
}
